import { formikMuiSelectField } from "venuescanner-js/react/components/MuiFields/muiSelectField";
import LocationField from "venuescanner-js/react/components/SelectField/LocationField";

export default formikMuiSelectField(LocationField);
